import classNames from 'classnames';
import copy from 'clipboard-copy';
import { ReactNode, useEffect, useState } from 'react';

import BasicButton from '../buttons/BasicButton';

import styles from '../../styles/fields/copy-field.module.css';

interface CopyFieldProps {
    value: string | null;
    children: ReactNode;
    className?: string | null;
    onCopy?: ((value: string | null) => void) | null;
}

function CopyField({ children, value, className, onCopy = null }: CopyFieldProps) {
    const [copied, setCopied] = useState(false);
    const onClickCopy = () => {
        copy(value);
        setCopied(true);
        if (onCopy !== null) {
            onCopy(value);
        }
    };

    useEffect(() => {
        let timeout = null;
        if (copied !== null) {
            timeout = setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
        return () => {
            if (timeout !== null) {
                clearTimeout(timeout);
            }
        };
    }, [copied]);
    return (
        <div className={classNames([styles.container, className])}>
            {children}
            <BasicButton className={styles.button} onClick={onClickCopy}>
                <span className={classNames(['material-symbols-rounded', styles.icon])}>
                    {copied ? 'check_circle' : 'content_copy'}
                </span>
            </BasicButton>
        </div>
    );
}

export default CopyField;
